import { createTheme } from '@mantine/core';
import { DEFAULT_THEME_COLOR, normalizeThemeColor } from './config/themeColors';

export function createArchimageTheme(primaryColor = DEFAULT_THEME_COLOR) {
  const color = normalizeThemeColor(primaryColor);
  return createTheme({
    fontFamily: "'DM Sans', system-ui, sans-serif",
    headings: { fontFamily: "'DM Sans', system-ui, sans-serif" },
    primaryColor: color,
    defaultRadius: 'md',
  });
}

/** Thème par défaut (avant chargement utilisateur). */
export const archimageTheme = createArchimageTheme();
